import React from 'react';
import { withSSR } from 'react-i18next';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { State } from 'store/types';
import { StorageRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

const WithI18 = withSSR()(StorageRemote);

registerWidget<State, Record<string, string>>(`${__NAME__}/storage`, state => {
  const router = getGlobalRouter();
  const {
    localization: { initialI18nStore, initialLanguage },
  } = state;
  const store = initWidgetData(state);

  return remoteProps => (
    <WithI18
      initialI18nStore={initialI18nStore}
      initialLanguage={initialLanguage}
      router={router}
      store={store}
      {...remoteProps}
    />
  );
});
